import { defineMessages } from 'react-intl';

type MessageKeys = 'chatOptionsForConversationButtonLabel' | 'chatRenameLabel' | 'chatDeleteLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		chatOptionsForConversationButtonLabel: {
			id: 'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label',
			defaultMessage: 'Chat options for {conversationName}',
			description:
				'Accessibility label (aria-label) for a button or menu trigger in a chat conversation list item within the AI conversation interface that opens options for a specific conversation. Shown as a screen reader announcement when the button is focused or hovered. The conversationName placeholder will be substituted with the name of the conversation (e.g., "Project Planning Discussion"). The purpose is to provide accessible information about which conversation\'s options will be opened for users with assistive technologies.',
		},
		chatRenameLabel: {
			id: 'ai-mate.chat-view.chat-item.chat-rename-label',
			defaultMessage: 'Rename',
			description:
				'Menu item label displayed in a dropdown menu in a chat conversation list item within the AI conversation interface. Shown as clickable text in a menu. When clicked, it opens a dialog or input field allowing users to rename the conversation. The purpose is to provide users with a way to change the name of a conversation for better organization.',
		},
		chatDeleteLabel: {
			id: 'ai-mate.chat-view.chat-item.chat-delete-label',
			defaultMessage: 'Delete',
			description:
				'Menu item label displayed in a dropdown menu in a chat conversation list item within the AI conversation interface. Shown as clickable text in a menu. When clicked, it opens a confirmation dialog and then permanently deletes the conversation. The purpose is to provide users with a way to remove conversations they no longer need.',
		},
	});

export default message;
